var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_c('img',{staticClass:"loading-gif",attrs:{"src":require("../img/loading.gif"),"alt":"Loading..."}})])
}]

export { render, staticRenderFns }